
import { Options, Vue } from "vue-class-component";

@Options({
  emits: ["click"],
  props: {
    hasBorder: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
})
export default class MDropdownItem extends Vue {
  hasBorder = true;
  disabled = false;

  handleClick(event: Event) {
    if (this.disabled) {
      return;
    }
    this.$emit("click", event);
  }
}
